/* eslint-disable sort-keys */
/* eslint-disable max-len */
export const KZ = {
  app: {
    confirmEmail: {
      title: 'Не удалось подтвердить адрес электронной почты',
      description: 'Вы уже ранее подтвердили свою электронную почту, или что-то пошло не так.',
      description2:
        'Попробуйте еще раз перейти по ссылке подтверждения позднее или обратитесь в нашу службу поддержки по телефону',
      phone: '(727) 237-77-04',
    },
    updateEmail: {
      success: {
        title: 'Адрес электронной почты успешно обновлен',
      },
      error: {
        title: 'Не удалось обновить адрес электронной почты',
        description:
          'Попробуйте еще раз перейти по ссылке подтверждения позднее или обратитесь в нашу службу поддержки по телефону',
        phone: '(727) 237-77-04',
      },
    },
    footer: {
      copyright: 'МЦФЭР-Казахстан',
    },
    logon: {
      companyDescription: '',
      title: 'Вход в продукты',
    },
    formComponents: {
      header: {
        logoLink: 'https://action.group/',
      },
      form: {
        submitButton: {
          confirmation: {
            firstText: 'Нажимая на кнопку "Зарегистрироваться", вы принимаете условия',
            conditionalTitle: 'пользовательского соглашения.',
          },
        },
        phone: {
          validation: {
            required: 'Обязательно напишите телефон. Пример: +7 787 123 4567',
            phoneFormat: 'Неправильный формат телефона. Пример: +7 787 123 4567',
          },
        },
      },
    },
    outdatedLink: {
      button: {
        href: '/Logon',
      },
    },
    shortForm: {
      form: {
        title: {
          phone: 'Укажите номер вашего телефона',
        },
        postAndFormShortuserAgreements: {
          secondText: '.',
        },
      },
    },
  },
}
